export enum PetArmature {
    IDLE = 'sitting',
    WALKING = 'walking',
    DIGGING = 'digging',
    IDLE_TO_WALKING = 'sitting_to_walking',
    WALKING_TO_IDLE = 'walking_to_sitting',
    MINI_GAME_HUNGRY = 'mini_game_hungry',
    MINI_GAME_FED = 'mini_game_fed',
    MY_FARM = 'my_farm',
}
